import { useMemo } from 'react';
import { theme } from '@utility/theme';

export const useStripeOptions = () => {
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontFamily: 'Nunito Sans',
          fontSize: '16px',
          color: 'rgba(0,0,0,.87)',
          letterSpacing: 'normal',
          '::placeholder': {
            color: 'rgba(191,191,191,.87)',
            fontSize: '12px',
            fontFamily: 'Nunito Sans',
          },
          ':focus::placeholder': {
            color: 'rgba(115,115,115,.87)',
          },
        },
        invalid: {
          color: theme.colors.danger,
        },
      },
    }),
    [],
  );

  return options;
};
